<template>
  <ModalLayout icon="send" :title="`Send ${meta?.flight ? 'flight' : 'campaign'} to review?`" @close="close">
    <div v-if="meta?.flight" class="text-review">
      Are you sure you want to send '<strong>{{ name }}</strong
      >' to review?<br />
      Ensure that all flight details and assets are final. You won’t be able to make changes after submission.
    </div>
    <div v-else class="text-review">
      Are you sure you want to send '<strong>{{ name }}</strong
      >' to review? <br />Ensure that all campaign details and assets are final. You won't be able to make changes after submission.
    </div>

    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" icon="el-icon-s-promotion" type="primary" :loading="loading" @click="sendToReview"
        >Send to review</el-button
      >
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from './ModalLayout.vue'
export default {
  name: 'SendToReview',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    name() {
      return this.meta?.flight ? `${this.meta?.flight.name}` : this.meta?.campaign?.name
    },
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async sendToReview() {
      this.loading = true
      try {
        await this.$store.dispatch('socialBoostCampaign/sendToReview', {
          campaign_id: this.meta?.id || this.$route.params.id,
          flight_id: this.meta?.flight_id || this.$route.params.flight_id,
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
        this.$store.dispatch('socialBoostCampaign/getCampaign', { id: this.meta?.id || this.$route.params.id })
        this.close()
      }
    },
  },
}
</script>
